<template>
  <div>
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <!-- HEADMENU -->
      <div class="row">
        <div class="col-xl-12 block br-t-l-0 mb-3">
          <!-- TODO: Headline ggf. anpassen-->
          <head-menu
            :col="12"
            class="d-xl-flex"
            :headline="'Modulunterricht'"
          ></head-menu>
          <div class="row mt-2 d-flex justify-content-between">
            <div class="ml-4">
              <button
                class="btn btn-success mr-2"
                @click="speichern"
                @shortkey="speichern"
                v-shortkey.once="['ctrl', 's']"
              >
                <span>{{ $t('global.save') }}</span>
              </button>

              <button
                class="btn btn-primary"
                @click="startRepetentenprozess"
              >
                <font-awesome-icon
                  icon="fa-regular fa-list-check"
                  class="mr-2"
                />
                <span>Repetenten</span>
              </button>

              <!-- TODO: Bedingung reports vorhanden hinzufügen-->
              <!-- TODO: Printouts konfigurieren -->
              <b-dropdown
                variant="primary ml-2"
                v-if="
                  validCarbonePrintouts($CONST('CARBONEPRINTOUTS')).length > 0
                "
                :disabled="veranstaltung.id == null"
              >
                <template slot="button-content">
                  <font-awesome-icon
                    icon="fa-duotone fa-print"
                    class="mr-2"
                  />
                  <em>{{ $t('global.output') }}</em>
                </template>

                <!--Carbone-->
                <b-dropdown-item
                  v-for="carboneprint in validCarbonePrintouts(
                    $CONST('CARBONEPRINTOUTS')
                  )"
                  :key="carboneprint.id"
                  @click="oeffnePrintoutDatumModal(carboneprint)"
                >
                  {{ carboneprint.value }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- AUSWAHL AUSBILDUNGSPLAN UND VERANSTALTUNG -->
      <div class="row mb-3">
        <div class="col-12 block belegliste">
          <div class="row">
            <div class="col-12 d-flex">
              <div class="col-3 form-group z-11">
                <v-select
                  v-model="ausbildungsplan"
                  :options="ausbildungsplaene"
                  :reduce="(v) => v.id"
                  :getOptionLabel="(plan) => plan.bezeichnung"
                  placeholder="Ausbildungsplan"
                >
                  <span slot="no-options">{{ $t('global.nodatafound') }}</span>
                </v-select>
                <label>Ausbildungsplan</label>
              </div>
              <div
                v-if="ausbildungsplan != null"
                class="col-3"
              >
                <single-select-veranstaltung
                  id="modulunterricht-veranstaltung"
                  :label="'Klasse wählen'"
                  :veranstaltung="veranstaltung"
                  :allowOpen="false"
                  editable
                  @confirmed="setVeranstaltung"
                />
              </div>
              <div class="col-2 d-flex align-items-center">
                <button
                  class="btn btn-primary"
                  :disabled="!ausbildungsplan"
                  @click="getPromotionen"
                >
                  <font-awesome-icon
                    icon="fa-duotone fa-magnifying-glass"
                    class="mr-2"
                  />
                  <span>{{ $t('global.search') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- PROMOTIONSBLÖCKE REITER -->
      <div class="row">
        <div
          class="block block-kopf clickable"
          v-for="(promotionsblock, index) in promotionsbloecke"
          :key="'promotionsblock-' + index"
          @click="setPromotionsblock(index)"
          :style="
            aktiverPromotionsblock == index
              ? styleHeadlineSelected
              : styleHeadline
          "
        >
          <span class="col primary-headline-text p-0">
            {{ promotionsblock.designation }} ({{
              anzahlStudentenproBlock(promotionsblock.id)
            }})
          </span>
        </div>
      </div>
      <!-- PROMOTIONEN LISTE -->
      <div class="row">
        <div class="col-12 block belegliste br-t-l-0">
          <b-table
            class="clickable table-not-rounded"
            no-border-collapse
            responsive
            ref="selectableTable"
            small
            tbody-tr-class="item"
            show-empty
            selectable
            fixed
            :items="promotionen"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :busy="isBusy"
            @row-clicked="details"
          >
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #empty>
              <div
                v-if="ladeFehler"
                class="text-center text-danger my-2"
              >
                <strong>{{ $t('global.errorwhileloading') }}</strong>
              </div>
              <div
                v-if="!ladeFehler"
                class="text-center text-primary my-2"
              >
                <strong>{{ $t('global.nodataavailable') }}</strong>
              </div>
            </template>

            <template v-slot:head(selected)="row">
              <b-form-checkbox
                v-model="row.selected"
                @input="selectAllPromotionen(row)"
              ></b-form-checkbox>
            </template>

            <template v-slot:cell(selected)="row">
              <b-form-checkbox
                v-model="row.item.selected"
                @input="onPromotionenSelected(row)"
              ></b-form-checkbox>
            </template>

            <template #cell(nr)="data">
              {{ data.index + 1 }}
            </template>

            <template v-slot:cell(chevron)="row">
              <div v-if="row.detailsShowing">
                <font-awesome-icon icon="fa-solid fa-chevron-up" />
              </div>
              <div v-if="!row.detailsShowing">
                <font-awesome-icon icon="fa-solid fa-chevron-down" />
              </div>
            </template>

            <!-- DETAILS -->
            <template #row-details="row">
              <b-card class="cursor-default">
                <!-- TABELLE HEADER -->
                <div class="row m-2 mb-4">
                  <div
                    class="col-12 p-0 d-flex text-bold border-bottom border-2 border-primary"
                  >
                    <div
                      :class="isCpVergabe ? 'col-3' : 'col-6'"
                      class="p-0 d-flex"
                    >
                      <div
                        class="col-6 p-0 pl-2 text-overflow-ellipsis"
                        data-toggle="tooltip"
                        title="Modul"
                      >
                        Modul
                      </div>
                      <div
                        class="col-6 p-0 pl-2 text-overflow-ellipsis"
                        data-toggle="tooltip"
                        title="Fach"
                      >
                        Fach
                      </div>
                    </div>
                    <div
                      :class="isCpVergabe ? 'col-3' : 'col-4'"
                      class="p-0 d-flex"
                    >
                      <div
                        class="col p-0 pl-2 text-overflow-ellipsis"
                        data-toggle="tooltip"
                        title="Note"
                      >
                        Note
                      </div>
                      <div
                        class="p-0 text-center text-overflow-ellipsis"
                        :class="zeigeGewichtungen ? 'col-2' : 'col-4'"
                        data-toggle="tooltip"
                        title="Kommentare"
                        v-if="zeigeKommentare"
                      >
                        Kommentare
                      </div>
                      <div
                        class="p-0 text-center text-overflow-ellipsis"
                        :class="zeigeKommentare ? 'col-2' : 'col-4'"
                        data-toggle="tooltip"
                        title="Gewichtung Fach"
                        v-if="zeigeGewichtungen"
                      >
                        Gewichtung Fach
                      </div>
                    </div>
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 pl-2 text-center text-overflow-ellipsis"
                      data-toggle="tooltip"
                      title="Min. CP"
                    >
                      Min. CP
                    </div>
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 pl-2 text-center text-overflow-ellipsis"
                      data-toggle="tooltip"
                      title="Max. CP"
                    >
                      Max. CP
                    </div>
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 pl-2 text-center text-overflow-ellipsis"
                      data-toggle="tooltip"
                      title="Schwellenwert"
                    >
                      Schwelle
                    </div>
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 pl-2 text-center text-overflow-ellipsis"
                      data-toggle="tooltip"
                      title="Erz. CP"
                    >
                      Erz. CP
                    </div>
                    <div class="col-2 p-0 d-flex">
                      <div
                        class="p-0 pl-2 text-overflow-ellipsis"
                        :class="zeigeGewichtungen ? 'col-6' : 'col-12'"
                        data-toggle="tooltip"
                        :title="isCpVergabe ? 'CP Gruppe' : 'Modulnote'"
                      >
                        {{ isCpVergabe ? 'CP Gruppe' : 'Modulnote' }}
                      </div>
                      <div
                        class="col-6 p-0 text-center text-overflow-ellipsis"
                        data-toggle="tooltip"
                        title="Gewichtung Modul"
                        v-if="zeigeGewichtungen"
                      >
                        Gewichtung Modul
                      </div>
                    </div>
                  </div>

                  <!-- TABELLE BODY -->
                  <div
                    class="col-12 p-0 d-flex border-bottom border-primary"
                    v-for="(promotionsgruppe, promotionsgruppenIndex) in row
                      .item.promotionblocks[aktiverPromotionsblock]
                      .promotiongroups"
                    :key="'promotionsgruppe-' + promotionsgruppenIndex"
                    :style="setBackgroundcolor(promotionsgruppenIndex)"
                  >
                    <!-- PROMOTIONSGRUPPEN UND MODULE -->
                    <div
                      :class="isCpVergabe ? 'col-3' : 'col-6'"
                      class="p-0 d-flex border-right border-1 border-primary"
                    >
                      <!-- PROMOTIONSGRUPPEN -->
                      <div
                        class="col-6 p-0 pl-2 d-flex h-100-p align-items-center text-overflow-ellipsis text-normal"
                        v-tooltip.hover
                        :title="promotionsgruppe.bezeichnung"
                      >
                        <span class="text-overflow-ellipsis text-normal">
                          {{ promotionsgruppe.designation }}
                        </span>
                      </div>

                      <!-- MODULE -->
                      <div
                        class="col-6 p-0 d-flex flex-column justify-content-center border-left border-primary"
                      >
                        <div
                          v-for="(
                            subject, subjectIndex
                          ) in promotionsgruppe.subjects"
                          :key="'subject-' + subjectIndex"
                        >
                          <div
                            class="py-2 px-2 d-flex"
                            :class="
                              !(
                                subjectIndex ===
                                promotionsgruppe.subjects.length - 1
                              )
                                ? 'border-bottom border-primary'
                                : ''
                            "
                          >
                            <span class="text-overflow-ellipsis text-normal">
                              {{
                                subject.short
                                  ? subject.short + ' - ' + subject.designation
                                  : subject.designation
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- NOTEN FACH UND GEWICHTUNG FACH-->
                    <div
                      :class="isCpVergabe ? 'col-3' : 'col-4'"
                      class="p-0 d-flex border-right border-1 border-primary"
                    >
                      <div
                        class="col p-0 d-flex flex-column justify-content-center"
                      >
                        <!-- NOTEN FACH -->
                        <div
                          v-for="(
                            subject, subjectIndex
                          ) in promotionsgruppe.subjects"
                          :key="'subject-' + subjectIndex"
                          :class="setTornotenStyle(subject)"
                        >
                          <div
                            class="py-2 px-2 d-flex justify-content-center"
                            :class="
                              !(
                                subjectIndex ===
                                promotionsgruppe.subjects.length - 1
                              )
                                ? 'border-bottom border-primary'
                                : ''
                            "
                          >
                            <div
                              v-for="(
                                bewertung, bewertungsIndex
                              ) in subject.tor_grades"
                              :key="'bewertung-' + bewertungsIndex"
                            >
                              <!-- Note angerechnet -->
                              <div
                                class="d-flex justify-content-center"
                                v-if="bewertung.credited"
                              >
                                <div class="mr-2">Angerechnet</div>

                                <div
                                  class="clickable"
                                  data-toggle="tooltip"
                                  title="Anrechnung entfernen"
                                  @click="bewertung.credited = false"
                                >
                                  <font-awesome-icon
                                    icon="fa-duotone fa-trash"
                                  />
                                </div>
                              </div>

                              <!-- MANUELLE NOTE VORHANDEN -->
                              <div
                                class="d-flex justify-content-center"
                                v-if="
                                  istHoechsteNote(subject, bewertungsIndex) &&
                                  !bewertung.credited
                                "
                              >
                                <div
                                  v-if="
                                    !bewertung.input_active &&
                                    hatManuelleAnpassung(bewertung)
                                  "
                                  class="mr-2"
                                >
                                  <font-awesome-icon
                                    v-tooltip.hover
                                    :title="tooltipManualGradeInfo(bewertung)"
                                    icon="fa-solid fa-circle-info"
                                    class="mx-auto text-primary"
                                    style="font-size: 16px"
                                  />
                                </div>

                                <!-- MEHRERE NOTEN VORHANDEN -->

                                <div
                                  v-if="
                                    istRepetend(subject) &&
                                    !bewertung.input_active
                                  "
                                  class="mr-2"
                                >
                                  <font-awesome-icon
                                    v-tooltip.hover
                                    :title="tooltipLowestGradeInfo(subject)"
                                    icon="fa-duotone fa-exclamation-triangle"
                                    class="mx-auto text-primary"
                                    style="font-size: 16px"
                                  />
                                </div>

                                <!-- DEFINITIVE NOTE ANZEIGEN (höchste Manuelle Note falls vorhanden, ansonsten höchste Note)-->

                                <div
                                  v-if="
                                    !bewertung.input_active &&
                                    istHoechsteNote(subject, bewertungsIndex)
                                  "
                                  class="mr-2 note-display-wrapper d-flex align-items-center"
                                >
                                  <span class="note-value">
                                    {{ getAnzeigeNote(bewertung) }}
                                  </span>

                                  <span
                                    class="note-edit-icon clickable ml-1"
                                    data-toggle="tooltip"
                                    title="Note bearbeiten"
                                    @click.stop="openInput(bewertung)"
                                  >
                                    <font-awesome-icon
                                      icon="fa-regular fa-pencil"
                                    />
                                  </span>
                                </div>

                                <!-- NOTE MANUELL ANPASSEN -->

                                <div
                                  v-if="bewertung.input_active"
                                  class="d-flex align-items-center justify-content-center h-21-px"
                                >
                                  <!-- TEXTWAHL-NOTE -->
                                  <template
                                    v-if="istTextwahlBewertung(bewertung)"
                                  >
                                    <div class="col-7 form-group m-0 p-0">
                                      <v-select
                                        v-model="tempManualTextSelectionValue"
                                        :options="textwahlwerte"
                                        :getOptionLabel="
                                          (opt) => opt.bezeichnung
                                        "
                                        label="bezeichnung"
                                        placeholder="Wert wählen"
                                      >
                                        <span slot="no-options">
                                          {{ $t('global.taptosearch') }}
                                        </span>
                                      </v-select>
                                    </div>

                                    <button
                                      class="btn btn-sm btn-success btn-tiny ml-1"
                                      data-toggle="tooltip"
                                      title="Textwahlnote übernehmen"
                                      :disabled="!tempManualTextSelectionValue"
                                      @click="
                                        setManualTextSelectionValue(bewertung)
                                      "
                                    >
                                      <font-awesome-icon
                                        icon="fa-solid fa-check"
                                      />
                                    </button>
                                  </template>

                                  <!-- NUMERISCHE NOTE -->
                                  <template v-else>
                                    <div class="col-3 form-group m-0 p-0">
                                      <input
                                        v-model="tempManualGrade"
                                        class="form-control text-center"
                                        :placeholder="
                                          bewertung.definitive_grade
                                        "
                                      />
                                    </div>
                                    <button
                                      class="btn btn-sm btn-success btn-tiny ml-1"
                                      data-toggle="tooltip"
                                      :title="tooltipManualGrade()"
                                      :disabled="validateManualGrade()"
                                      @click="setManualGrade(bewertung)"
                                    >
                                      <font-awesome-icon
                                        icon="fa-solid fa-check"
                                      />
                                    </button>
                                  </template>

                                  <!-- ANRECHNEN -->

                                  <div
                                    class="btn btn-sm btn-primary btn-tiny ml-1"
                                    data-toggle="tooltip"
                                    title="Fach anrechnen"
                                    @click="
                                      ;(bewertung.credited = true),
                                        (bewertung.input_active = false),
                                        (tempManualGrade = null),
                                        (tempManualTextSelectionValue = null)
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-duotone fa-file-certificate"
                                    />
                                  </div>

                                  <!-- MANUELLE ANPASSUNG ENTFERNEN -->
                                  <div
                                    class="btn btn-sm btn-danger btn-tiny ml-1"
                                    data-toggle="tooltip"
                                    title="Manuelle Note entfernen"
                                    @click="
                                      resetManuelleNote(
                                        subject,
                                        bewertungsIndex
                                      )
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-duotone fa-trash"
                                    />
                                  </div>

                                  <!-- SCHLIESSEN -->
                                  <div
                                    class="btn btn-sm btn-secondary btn-tiny ml-1"
                                    data-toggle="tooltip"
                                    title="Schliessen"
                                    @click="
                                      ;(bewertung.input_active = false),
                                        (tempManualGrade = null),
                                        (tempManualTextSelectionValue = null)
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-regular fa-xmark"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- KEINE TORNOTEN FÜR DAS FACH VORHANDEN -->
                            <div
                              class="d-flex align-items-center bg-grey"
                              v-if="subject.tor_grades.length == 0"
                            >
                              <div>-</div>

                              <!-- Numerische Note hinzufügen -->
                              <div
                                class="clickable ml-2"
                                data-toggle="tooltip"
                                title="Numerische Note hinzufügen"
                                @click="noteHinzufuegenNumerisch(subject)"
                              >
                                <font-awesome-icon icon="fa-regular fa-plus" />
                              </div>

                              <!-- Textwahlnote hinzufügen -->
                              <div
                                class="clickable ml-2"
                                data-toggle="tooltip"
                                title="Textwahlnote hinzufügen"
                                @click="noteHinzufuegenTextwahl(subject)"
                              >
                                <font-awesome-icon icon="fa-regular fa-text" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- KOMMENTAR FACH -->
                      <div
                        class="p-0 d-flex flex-column justify-content-center border-left border-primary"
                        :class="zeigeGewichtungen ? 'col-2' : 'col-4'"
                        v-if="zeigeKommentare"
                      >
                        <div
                          v-for="(
                            subject, subjectIndex
                          ) in promotionsgruppe.subjects"
                          :key="'subject-' + subjectIndex"
                        >
                          <div
                            class="py-2 px-2 d-flex justify-content-center"
                            :class="
                              !(
                                subjectIndex ===
                                promotionsgruppe.subjects.length - 1
                              )
                                ? 'border-bottom border-primary'
                                : ''
                            "
                          >
                            <span
                              v-if="getKommentarVonHoechsterNote(subject) == ''"
                            >
                              <font-awesome-icon
                                icon="fa-regular fa-circle-plus"
                                class="mr-2"
                                @click="oeffneInputModal(subject)"
                              />
                            </span>

                            <span
                              v-else
                              v-tooltip.hover="
                                getKommentarVonHoechsterNote(subject)
                              "
                            >
                              <font-awesome-icon
                                icon="fa-duotone fa-comment clickable"
                                class="mr-2"
                                @click="oeffneInputModal(subject)"
                              />
                            </span>
                            <!-- <span
                              class="text-overflow-ellipsis text-normal"
                              v-tooltip.hover="
                                getKommentarVonHoechsterNote(subject)
                              "
                            >
                              {{ getKommentarVonHoechsterNote(subject) }}
                            </span> -->
                          </div>
                        </div>
                      </div>
                      <!-- GEWICHTUNG FACH -->
                      <div
                        class="p-0 d-flex flex-column justify-content-center border-left border-primary"
                        :class="zeigeKommentare ? 'col-2' : 'col-4'"
                        v-if="zeigeGewichtungen"
                      >
                        <div
                          v-for="(
                            subject, subjectIndex
                          ) in promotionsgruppe.subjects"
                          :key="'subject-' + subjectIndex"
                        >
                          <div
                            class="py-2 px-2 d-flex justify-content-center"
                            :class="
                              !(
                                subjectIndex ===
                                promotionsgruppe.subjects.length - 1
                              )
                                ? 'border-bottom border-primary'
                                : ''
                            "
                          >
                            <span class="text-overflow-ellipsis text-normal">
                              {{ subject.weighting }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- MIN. CP PRO FACH (nur CP-Modus) -->
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 border-right border-1 border-primary text-center"
                    >
                      <div
                        v-for="(fach, fachIndex) in promotionsgruppe.subjects ||
                        []"
                        :key="'min-cp-' + fachIndex"
                        class="py-2 px-1 text-center"
                        :class="
                          fachIndex !== promotionsgruppe.subjects.length - 1
                            ? 'border-bottom border-primary'
                            : ''
                        "
                      >
                        {{ fach.dynamische_vergabe ? fach.min_cp : '-' }}
                      </div>
                    </div>

                    <!-- MAX. CP PRO FACH (nur CP-Modus) -->
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 border-right border-1 border-primary text-center"
                    >
                      <div
                        v-for="(fach, fachIndex) in promotionsgruppe.subjects ||
                        []"
                        :key="'max-cp-' + fachIndex"
                        class="py-2 px-1 text-center"
                        :class="
                          fachIndex !== promotionsgruppe.subjects.length - 1
                            ? 'border-bottom border-primary'
                            : ''
                        "
                      >
                        {{ fach.cp }}
                      </div>
                    </div>

                    <!-- SCHWELLENWERT PRO FACH (nur CP-Modus) -->
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 border-right border-1 border-primary text-center"
                    >
                      <div
                        v-for="(fach, fachIndex) in promotionsgruppe.subjects ||
                        []"
                        :key="'schwelle-' + fachIndex"
                        class="py-2 px-1 text-center"
                        :class="
                          fachIndex !== promotionsgruppe.subjects.length - 1
                            ? 'border-bottom border-primary'
                            : ''
                        "
                      >
                        {{
                          fach.schwellenwert != null ? fach.schwellenwert : '-'
                        }}
                      </div>
                    </div>

                    <!-- ERZ. CP PRO FACH (nur CP-Modus) -->
                    <div
                      v-if="isCpVergabe"
                      class="col-1 p-0 border-right border-1 border-primary text-center"
                    >
                      <div
                        v-for="(fach, fachIndex) in promotionsgruppe.subjects ||
                        []"
                        :key="'erz-cp-' + fachIndex"
                        class="py-2 px-1 text-center font-weight-bold"
                        :class="
                          fachIndex !== promotionsgruppe.subjects.length - 1
                            ? 'border-bottom border-primary'
                            : ''
                        "
                      >
                        {{
                          getHoechsteNote(fach) ? getHoechsteNote(fach).cp : '-'
                        }}
                      </div>
                    </div>

                    <!-- PROMOTIONSGRUPPEN SCHNITT UND GEWICHTUNG -->

                    <div class="col-2 p-0 d-flex">
                      <div
                        class="p-0 d-flex flex-column justify-content-center"
                        :class="zeigeGewichtungen ? 'col-6' : 'col-12'"
                      >
                        <!-- PROMOTIONSGRUPPE SCHNITT (Noten-Modus) / CP (CP-Modus) -->
                        <div
                          class="h-100-p d-flex justify-content-center align-items-center"
                          :class="
                            isCpVergabe
                              ? promotionsgruppe.passed
                                ? 'bg-success-light'
                                : 'bg-danger-light'
                              : promotionsgruppe.average_grade &&
                                promotionsgruppe.average_grade != 0 &&
                                promotionsgruppe.average_grade != 'NaN' &&
                                promotionsgruppe.average_grade != undefined
                              ? promotionsgruppe.passed
                                ? 'bg-success-light'
                                : 'bg-danger-light'
                              : 'bg-grey'
                          "
                        >
                          <template v-if="isCpVergabe">
                            {{ promotionsgruppe.cp }} /
                            {{ promotionsgruppe.min_cp }} CP
                          </template>
                          <template v-else>
                            {{
                              promotionsgruppe.average_grade &&
                              promotionsgruppe.average_grade != 0 &&
                              promotionsgruppe.average_grade != 'NaN' &&
                              promotionsgruppe.average_grade != undefined
                                ? promotionsgruppe.average_grade
                                : '-'
                            }}
                          </template>
                        </div>
                      </div>
                      <!-- GEWICHTUNG PROMOTIONSGRUPPE -->
                      <div
                        class="col-6 p-0 text-center text-overflow-ellipsis border-left border-1 border-primary h-100-p d-flex justify-content-center align-items-center"
                        v-if="zeigeGewichtungen"
                      >
                        {{ promotionsgruppe.weighting }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- TABELLE FUSSNOTE (ZUSAMMENFASSUNG UND BUTTONS)-->
                <div class="row m-2">
                  <div class="col-12 p-0 d-flex">
                    <!-- PROMOTIONSSTATUS UND SCHNITT-->
                    <div class="col-8 p-0 d-flex text-bold">
                      <div class="col-4 p-0 pl-2 d-flex align-items-center">
                        {{
                          row.item.promotionblocks[aktiverPromotionsblock]
                            .average_passed
                            ? 'Weiterstudieren ohne Auflagen'
                            : 'Nicht weiterstudieren'
                        }}
                      </div>
                      <div
                        class="col-2 p-0 text-center d-flex justify-content-center align-items-center"
                      >
                        <template v-if="isCpVergabe">
                          {{
                            row.item.promotionblocks[aktiverPromotionsblock].cp
                          }}
                          /
                          {{
                            row.item.promotionblocks[aktiverPromotionsblock]
                              .min_cp
                          }}
                          CP
                        </template>
                        <template v-else>
                          {{
                            row.item.promotionblocks[aktiverPromotionsblock]
                              .average_grade
                          }}
                        </template>
                      </div>
                    </div>
                    <!-- TOGGLE BUTTONS -->
                    <div class="col ml-auto d-flex">
                      <div
                        class="btn ml-auto mr-2"
                        @click="zeigeKommentare = true"
                        v-if="!zeigeKommentare"
                      >
                        Zeige Kommentare
                      </div>
                      <div
                        class="btn btn-primary ml-auto mr-2"
                        @click="zeigeKommentare = false"
                        v-if="zeigeKommentare"
                      >
                        Zeige Kommentare
                      </div>
                      <div
                        class="btn mr-2"
                        @click="zeigeGewichtungen = true"
                        v-if="!zeigeGewichtungen"
                      >
                        Zeige Gewichtungen
                      </div>
                      <div
                        class="btn btn-primary mr-2"
                        @click="zeigeGewichtungen = false"
                        v-if="zeigeGewichtungen"
                      >
                        Zeige Gewichtungen
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <loading-overlay v-show="loading"></loading-overlay>
    <input-modal
      id="input-modal"
      headerText="Kommentar"
      :text="null"
      :showTextarea="true"
      :textareaValue="editingKommentar"
      textareaPlaceholder="Kommentar"
      textareaLabel="Kommentar"
      :ok="true"
      @ok="saveKommentar"
    />
    <datum-pdf-modal
      :id="'datum-pdf-modal'"
      @ok="generiereCarboneReport"
      :kategorie="category"
      :printout="printout"
    />
    <notenuebersicht-modul-modal
      :id="'notenuebersicht-modul-modal'"
      :bloecke="notenuebersichtBloecke"
      @ok="generiereNotenuebersicht"
    />
    <pdf-layer
      id="pdf-layer-promotion"
      ref="pdfLayerPromotion"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
      :files="pdfFiles"
    ></pdf-layer>
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import Navbar from '@/components/Navbar'

  import TorApi from '@/api/TorApi'
  import AppApi from '@/api/AppApi'
  import store from '@/store'
  import page from '@/mixins/Page'
  import server from '@/server'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import { BSpinner } from 'bootstrap-vue'

  import { LADE_AUSWAHLWERTE_NOTEN } from '@/store/noten/actions.type'
  import CarboneApi from '@/api/CarboneApi'

  import DatumPdfModal from '@/components/Modals/DatumPdfModal.vue'
  import NotenuebersichtModulModal from '@/components/Modals/NotenuebersichtModulModal.vue'
  import InputModal from '@/components/Modals/InputModal.vue'
  import SingleSelectVeranstaltung from '@/components/global/SingleSelectVeranstaltung.vue'
  // Carbone-Printout der Notenübersicht (Printoutkategorie "Notenuebersicht")
  const NOTENUEBERSICHT_APPKEY = 'notenuebersicht-modul'

  //TODO: Mockdata entfernen, wenn Call funktioniert
  //import TorGrades from '@/mock/TorGrades.json'

  export default {
    name: 'TorListe',
    components: {
      HeadMenu,
      Navbar,
      DatumPdfModal,
      NotenuebersichtModulModal,
      InputModal,
      SingleSelectVeranstaltung,
      BSpinner,
    },
    metaInfo() {
      return {
        titleTemplate: () => {
          return 'BX: ' + 'Modulunterricht'
        },
      }
    },
    mixins: [page],
    props: {},
    store,
    data() {
      return {
        name: 'PromotionsuebersichtModulunterricht',
        pdfPath: '',
        pdfFiles: [],
        sortBy: 'lastname',
        sortDesc: false,
        isBusy: false,
        ladeFehler: false,

        styleHeadlineSelected: {
          filter: 'none',
        },
        styleHeadline: {
          filter: 'brightness(0.9)',
        },
        aktiverPromotionsblock: 0,
        ausbildungsplan: null,
        ausbildungsplaene: [],
        tempManualGrade: null,
        tempManualTextSelectionValue: null,
        zeigeGewichtungen: false,
        zeigeKommentare: false,
        editingSubject: null,
        editingKommentar: '',
        veranstaltung: { id: null, bezeichnung: null },
        selectedPromotionenIDs: [],
        allPromotionenSelected: null,
        promotion: {},
        promotionen: [],
        promotionsbloecke: [],
        selectedObjects: [],
        category: null,
        printout: null,
        notenuebersichtBloecke: [],
        endpoint: null,
        carboneDate: null,
        carboneTyp: null,
        carboneInstitution: null,
        backgroundcolors: [
          '#F0F3FA',
          '#F2FAF9',
          '#F4F0EC',
          '#F8F3F9',
          '#F0F2EB',
          '#E7EBEA',
          '#F9F6F7',
          '#FAF5F2',
          '#F2F8F3',
          '#F9F7F5',
          '#F8F4E9',
          '#EEF1F0',
          '#F5F0F6',
          '#FAF2E9',
          '#F5E6E8',
        ],
      }
    },
    computed: {
      textwahlwerte: {
        get() {
          return this.$store.state.noten.textwahlwerte
        },
      },
      isCpVergabe() {
        return !!this.promotion?.cp_vergabe
      },
      fields() {
        const mittelspalte = this.isCpVergabe
          ? {
              key: 'ErreichteCP',
              sortable: true,
              searchable: false,
              label: 'Erreichte CP',
              formatter: (value, key, item) => {
                return this.getCP(item)
              },
              tdClass: (value, key, item) => {
                return this.getCPfarbe(item)
              },
            }
          : {
              key: 'Notendurchschnitt',
              sortable: true,
              searchable: false,
              label: 'Notendurchschnitt',
              formatter: (value, key, item) => {
                return this.getAverageGrade(item)
              },
              tdClass: (value, key, item) => {
                return this.getAverageGradeFarbe(item)
              },
            }

        return [
          { key: 'selected', label: '' },
          'nr',
          {
            key: 'student.number',
            sortable: true,
            searchable: false,
            label: 'Personennummer',
          },
          {
            key: 'student.lastname',
            sortable: true,
            searchable: false,
            label: 'Name',
          },
          {
            key: 'student.name',
            sortable: true,
            searchable: false,
            label: 'Vorname',
          },
          {
            key: 'Promotionsentscheid',
            sortable: true,
            searchable: false,
            label: 'Promotionsentscheid',
            formatter: (value, key, item) => {
              return this.getPromotionsentscheid(item)
            },
            tdClass: (value, key, item) => {
              return this.getPromotionsentscheidFarbe(item)
            },
          },
          mittelspalte,
          {
            key: 'chevron',
            label: '',
            tdClass: () => {
              return 'd-flex justify-content-center'
            },
          },
        ]
      },
      selectedIds() {
        return this.selectedPromotionenIDs
      },
    },
    watch: {
      ausbildungsplan(newVal) {
        console.log('ausbildungsplan changed', newVal)
        this.getPromotionen()
      },
    },
    created() {},
    mounted() {
      if (this.textwahlwerte.length === 0)
        this.$store.dispatch(`noten/${LADE_AUSWAHLWERTE_NOTEN}`)
      this.loadAusbildungsplaene()
    },
    methods: {
      async loadAusbildungsplaene() {
        try {
          const resp = await AppApi.get('liste-ausbildungsplan/', {
            params: { page: 0, count: 1000 },
          })
          this.ausbildungsplaene = Array.isArray(resp.data) ? resp.data : []
        } catch (e) {
          // silently fail
        }
      },
      getPromotionen() {
        //TODO: MockData entfernen, folgende drei Zeilen entfernen und Call einkommentieren
        /*this.promotion = TorGrades
        this.promotionen = this.promotion.torlist
        this.promotionsbloecke = this.promotion.promotionblocks*/

        console.log('ausbildungsplan ID:', this.ausbildungsplan?.id)

        // NEUER CALL:
        this.isBusy = true
        //Ausbildungsplan und Veranstaltung werden als Parameter mitgegeben
        TorApi.get('simulation/', {
          params: {
            educationplan: this.ausbildungsplan,
            event: this.veranstaltung?.id,
          },
        })
          .then((response) => {
            this.promotion = response.data
            this.promotionen = this.promotion.torlist
            this.promotionsbloecke = this.promotion.promotionblocks
            this.ladeFehler = false
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
            this.ladeFehler = true
          })
          .finally(() => {
            this.isBusy = false
          })
      },
      async speichern() {
        this.isBusy = true

        await this.notenZuZahlenFormatieren()

        TorApi.post('simulation/', this.promotion)
          .then((response) => {
            this.promotion = response.data
            this.promotionen = this.promotion.torlist
            this.promotionsbloecke = this.promotion.promotionblocks
            this.$notify({
              type: 'success',
              title: this.$t('notification.actionsuccessful'),
              text: 'Promotionen erfolgreich gespeichert.',
            })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
            this.ladeFehler = true
          })
          .finally(() => {
            this.isBusy = false
          })
      },
      notenZuZahlenFormatieren() {
        //Noten von String zu Number konvertieren, damit diese im Backend korrekt verarbeitet werden können
        this.promotionen.forEach((tor) => {
          tor.promotionblocks.forEach((block) => {
            block.average_grade = Number(block.average_grade)

            block.promotiongroups.forEach((group) => {
              group.average_grade = Number(group.average_grade)
              group.subjects.forEach((subject) => {
                subject.tor_grades.forEach((torGrade) => {
                  torGrade.tor_grade = Number(torGrade.tor_grade)
                  torGrade.manual_grade = Number(torGrade.manual_grade)
                  torGrade.definitive_grade = Number(torGrade.definitive_grade)
                })
              })
            })
          })
        })
      },
      setVeranstaltung(veranstaltung) {
        this.veranstaltung = veranstaltung
      },
      setPromotionsblock(index) {
        this.aktiverPromotionsblock = index
      },
      anzahlStudentenproBlock(blockID) {
        let count = 0

        this.promotionen.filter((promotion) => {
          count += promotion.promotionblocks.filter((block) => {
            if (block.id === blockID) {
              return true
            }
            return false
          })?.length
        })

        return count
      },
      selectAllPromotionen(row) {
        if (row.selected) {
          this.$refs.selectableTable.items.forEach((item) => {
            item.selected = true
          })
        } else {
          this.$refs.selectableTable.items.forEach((item) => {
            item.selected = false
          })
        }

        this.$forceUpdate()
        this.allPromotionenSelected = Date.now()
        this.onPromotionenSelected()
      },

      onPromotionenSelected() {
        const selected = this.$refs.selectableTable.items.filter(
          (item) => item.selected
        )

        this.selectedObjects = selected
        this.selectedPromotionenIDs = selected.map((item) => item.id)
      },
      details(item) {
        // Alle anderen Listeneinträge schliessen
        this.promotionen.forEach((p) => {
          if (p !== item) {
            this.$set(p, '_showDetails', false)
          }
        })

        // Nur den angeklickten toggeln
        this.$set(item, '_showDetails', !item._showDetails)
      },
      getPromotionsentscheid(item) {
        let promotion = item.promotionblocks[this.aktiverPromotionsblock]

        if (promotion.average_passed) {
          return 'Weiterstudieren ohne Auflagen'
        } else {
          return 'Nicht weiterstudieren'
        }

        // if (promotion.cp_passed && promotion.average_passed) {
        //   return 'Weiterstudieren ohne Auflagen'
        // } else if (!promotion.cp_passed && !promotion.average_passed) {
        //   return 'Nicht weiterstudieren'
        // } else if (
        //   (promotion.cp_passed && !promotion.average_passed) ||
        //   (!promotion.cp_passed && promotion.average_passed)
        // ) {
        //   return 'Weiterstudieren mit Auflagen'
        // }
      },

      getPromotionsentscheidFarbe(item) {
        let promotion = item.promotionblocks[this.aktiverPromotionsblock]

        if (promotion.average_passed) {
          return 'bg-success-light'
        } else {
          return 'bg-danger-light'
        }

        // if (promotion.cp_passed && promotion.average_passed) {
        //   return 'bg-success-light'
        // } else if (!promotion.cp_passed && !promotion.average_passed) {
        //   return 'bg-danger-light'
        // } else if (
        //   (promotion.cp_passed && !promotion.average_passed) ||
        //   (!promotion.cp_passed && promotion.average_passed)
        // ) {
        //   return 'bg-warning-light'
        // }
      },
      getAverageGrade(item) {
        const grade =
          item.promotionblocks[this.aktiverPromotionsblock].average_grade
        return grade && grade != 0 && grade != 'NaN' ? grade : '-'
      },

      getAverageGradeFarbe(item) {
        let promotion = item.promotionblocks[this.aktiverPromotionsblock]

        if (!promotion.average_grade || promotion.average_grade == 0) {
          return 'bg-grey'
        }
        if (promotion.average_grade >= 4.0) {
          return 'bg-success-light'
        } else {
          return 'bg-danger-light'
        }
      },

      getCP(item) {
        return item.promotionblocks[this.aktiverPromotionsblock].cp
      },

      getCPfarbe(item) {
        const promotion = item.promotionblocks[this.aktiverPromotionsblock]
        return promotion.cp >= promotion.min_cp
          ? 'bg-success-light'
          : 'bg-danger-light'
      },
      setBackgroundcolor(index) {
        const colorIndex = index % this.backgroundcolors.length
        return { backgroundColor: this.backgroundcolors[colorIndex] }
      },
      setTornotenStyle(subject) {
        // keine Noten: Neutral
        if (
          !subject ||
          !Array.isArray(subject.tor_grades) ||
          subject.tor_grades.length === 0
        ) {
          return 'bg-grey'
        }

        // Wenn irgendeine Note angerechnet wurde: immer grün
        if (subject.tor_grades.some((g) => g.credited === true)) {
          return 'bg-success-light'
        }

        const best = this.getHoechsteNote(subject)
        if (!best) {
          return 'bg-grey'
        }

        let isPassed

        // 1) Textwahl-Score (über IDs, via getTextSelectionScore)
        const textScore = this.getTextSelectionScore(best)
        if (textScore === 2) {
          // Bestanden
          isPassed = true
        } else if (textScore === 1) {
          // Nicht Bestanden
          isPassed = false
        }

        // 2) Fallback: passed-Flag vom Backend
        if (isPassed === undefined) {
          if (best.passed === true) {
            isPassed = true
          } else if (best.passed === false) {
            isPassed = false
          }
        }

        // 3) Fallback: numerische Note (Schwelle 3.8 wie bisher)
        if (isPassed === undefined) {
          const num = this.getEffectiveNumericGrade(best)
          if (num !== null && !Number.isNaN(num)) {
            isPassed = num >= 4
          }
        }

        if (isPassed === true) return 'bg-success-light'
        if (isPassed === false) return 'bg-danger-light'

        return 'bg-grey'
      },
      getAnzeigeNote(bewertung) {
        if (!bewertung) return '-'

        // 1) Textwahl (egal ob selection/choice, manuell/definitiv)
        const textObj = this.getTextwahlObject(bewertung)
        if (textObj && textObj.bezeichnung) {
          return textObj.bezeichnung
        }

        // 2) Manuelle Zahl
        const hasManualNumber =
          bewertung.manual_grade !== null &&
          bewertung.manual_grade !== undefined &&
          bewertung.manual_grade !== 'NaN' &&
          Number(bewertung.manual_grade) !== 0

        if (hasManualNumber) {
          return this.formatNoteNumber(bewertung.manual_grade)
        }

        // 3) Definitive Zahl
        const hasDefNumber =
          bewertung.definitive_grade !== null &&
          bewertung.definitive_grade !== undefined &&
          bewertung.definitive_grade !== 'NaN' &&
          Number(bewertung.definitive_grade) !== 0

        if (hasDefNumber) {
          return this.formatNoteNumber(bewertung.definitive_grade)
        }

        // 4) Nichts sinnvolles
        return '-'
      },

      formatNoteNumber(value) {
        if (value === null || value === undefined) return '-'

        // In String umwandeln und trimmen
        const raw = String(value).trim()
        if (!raw) return '-'

        // Versuchen, als Zahl zu interpretieren
        const num = Number(raw.replace('.'))
        if (Number.isNaN(num)) {
          // keine echte Zahl: Originalstring zurückgeben
          return raw
        }

        // Hat der Original-String bereits eine Dezimalstelle? (z.B. 4.5)
        if (/[.]\d+/.test(raw)) {
          return raw
        }

        // Keine Dezimalstelle vorhanden → genau eine anhängen
        return num.toFixed(1) // z.B. 5 wird "5.0"
      },
      getEffectiveNumericGrade(grade) {
        if (!grade) return null

        let raw = null

        // manuelle Zahl hat Vorrang, wenn gesetzt
        if (
          grade.manual_grade &&
          grade.manual_grade != 0 &&
          grade.manual_grade != 'NaN' &&
          grade.manual_grade != undefined
        ) {
          raw = grade.manual_grade
        } else if (
          grade.definitive_grade !== null &&
          grade.definitive_grade !== undefined &&
          grade.definitive_grade !== 'NaN'
        ) {
          raw = grade.definitive_grade
        }

        if (raw === null) return null

        const num = Number(String(raw).replace(',', '.'))
        return Number.isNaN(num) ? null : num
      },
      getGradeSortValue(grade) {
        if (!grade) return null

        const passedFlag = grade.passed === true ? 1 : 0
        const textScore = this.getTextSelectionScore(grade)

        let numeric = this.getEffectiveNumericGrade(grade)
        if (numeric == null) numeric = 0

        // Textwahl (Bestanden / Nicht Bestanden) überstimmt die reine Zahl
        const base = textScore !== null ? textScore : numeric

        return passedFlag * 10 + base
      },
      getHoechsteNote(subject) {
        if (
          !subject ||
          !Array.isArray(subject.tor_grades) ||
          subject.tor_grades.length === 0
        ) {
          return null
        }

        let best = null
        let bestScore = null

        subject.tor_grades.forEach((g) => {
          const score = this.getGradeSortValue(g)
          if (score === null || score === undefined) return

          // Fall: Eine Note/Textbewertung ist höher als die anderen
          if (best === null || score > bestScore) {
            best = g
            bestScore = score
            return
          }

          // Fall: Alle Noten/Textbewertungen sind gleich. Manuelle Überarbeitungen sollen priorisiert werden.
          if (score === bestScore) {
            const gHasManual = this.hatManuelleAnpassung(g)
            const bestHasManual = this.hatManuelleAnpassung(best)

            if (gHasManual && !bestHasManual) {
              best = g
              bestScore = score
            }
          }
        })

        return best
      },
      istHoechsteNote(subject, index) {
        if (
          !subject ||
          !Array.isArray(subject.tor_grades) ||
          !subject.tor_grades.length
        ) {
          return false
        }

        const best = this.getHoechsteNote(subject)
        if (!best) return false

        // nur genau dieses Objekt gilt als höchste Note
        return subject.tor_grades[index] === best
      },
      getKommentarVonHoechsterNote(subject) {
        const highest = this.getHoechsteNote(subject)

        if (!highest) {
          return ''
        }

        if (highest.comment && String(highest.comment).trim() !== '') {
          return highest.comment
        }

        return ''
      },

      getSchlechtesteBewertung(subject) {
        if (
          !subject ||
          !Array.isArray(subject.tor_grades) ||
          subject.tor_grades.length === 0
        ) {
          return null
        }

        let worst = null
        let worstScore = null

        subject.tor_grades.forEach((g) => {
          const score = this.getGradeSortValue(g)
          if (score === null || score === undefined) return

          if (worst === null || score < worstScore) {
            worst = g
            worstScore = score
          }
        })

        return worst
      },
      tooltipLowestGradeInfo(subject) {
        const lowest = this.getSchlechtesteBewertung(subject)

        if (!lowest) {
          return 'Dieses Fach wurde repetiert. Die tiefere Note war nicht vorhanden.'
        }

        // Anzeige-Wert (Textwahl oder Zahl)
        const displayValue = this.getAnzeigeNote(lowest)
        const numericValue = this.getEffectiveNumericGrade(lowest)

        let text = 'Dieses Fach wurde repetiert. Die tiefere Note war: '

        if (displayValue && displayValue !== '-' && displayValue !== '') {
          text += displayValue
        } else if (
          numericValue !== null &&
          numericValue !== undefined &&
          !Number.isNaN(numericValue)
        ) {
          text += numericValue
        } else {
          text += 'nicht vorhanden'
        }

        if (lowest.comment && String(lowest.comment).trim() !== '') {
          text += `. Kommentar: ${lowest.comment}`
        }

        return text
      },

      getTextwahlObject(grade) {
        if (!grade) return null

        // Reihenfolge: manuell > definitive > ursprüngliche Auswahl
        return (
          grade.manual_text_selection_value ||
          grade.manual_text_choice_value ||
          grade.definitive_text_choice_value ||
          grade.text_selection_value ||
          grade.text_choice_value ||
          null
        )
      },

      getTextSelectionScore(grade) {
        //Aktuell Hardcodete IDs (zukünftig anhand Regelsätzen)
        if (!grade) return null

        const textObj = this.getTextwahlObject(grade)
        if (!textObj || !textObj.id) return null

        const textwahlId = String(textObj.id)

        if (textwahlId === '18A4A9963F5') {
          // "Nicht Bestanden"
          return 1
        }

        if (textwahlId === '18A4A991D51') {
          // "Bestanden"
          return 2
        }

        return null
      },
      hatManuelleAnpassung(bewertung) {
        if (!bewertung) return false

        // Numerische manuelle Anpassung
        const hasManualNumber =
          bewertung.manual_grade !== null &&
          bewertung.manual_grade !== undefined &&
          bewertung.manual_grade !== 'NaN' &&
          Number(bewertung.manual_grade) !== 0 &&
          Number(bewertung.manual_grade) !== Number(bewertung.tor_grade)

        // Textwahl manuell angepasst
        const manualText = bewertung.manual_text_selection_value
        const originalText = bewertung.text_selection_value

        const hasManualText =
          manualText &&
          manualText.id &&
          (!originalText ||
            !originalText.id ||
            originalText.id !== manualText.id)

        return hasManualNumber || hasManualText
      },
      oeffneInputModal(subject) {
        this.editingSubject = subject || null
        this.editingKommentar = subject
          ? this.getKommentarVonHoechsterNote(subject) || ''
          : ''

        this.$bus.$emit('open-modal', 'input-modal')
      },
      saveKommentar(neuerText) {
        if (!this.editingSubject) return

        const highest = this.getHoechsteNote(this.editingSubject)
        if (!highest) return

        this.$set(highest, 'comment', (neuerText || '').trim() || null)

        this.editingSubject = null
        this.editingKommentar = ''
      },
      istRepetend(subject) {
        if (subject.tor_grades.length == 1) {
          return false
        } else {
          return true
        }
      },
      openInput(bewertung) {
        // Alle offenen Inputs schliessen
        this.promotionen.forEach((promotion) => {
          promotion.promotionblocks.forEach((block) => {
            block.promotiongroups.forEach((group) => {
              group.subjects.forEach((subject) => {
                subject.tor_grades.forEach((grade) => {
                  grade.input_active = false
                })
              })
            })
          })
        })

        this.tempManualGrade = null
        this.tempManualTextSelectionValue = null

        // Textwahlnote Dropdown vorbelegen
        if (this.istTextwahlBewertung(bewertung)) {
          const textObj =
            bewertung.manual_text_selection_value ||
            bewertung.text_selection_value

          if (textObj && textObj.id) {
            const fromStore = (this.textwahlwerte || []).find(
              (t) => String(t.id) === String(textObj.id)
            )
            this.tempManualTextSelectionValue = fromStore || textObj
          }
        } else {
          // Numerische Note: Eingabefeld optional mit bestehender manueller Note füllen
          if (
            bewertung.manual_grade &&
            bewertung.manual_grade != 0 &&
            bewertung.manual_grade != 'NaN' &&
            bewertung.manual_grade != undefined
          ) {
            this.tempManualGrade = bewertung.manual_grade
          }
        }

        // Nur die geklickte Bewertung öffnen
        bewertung.input_active = true
      },

      resetManuelleNote(subject, index) {
        if (subject.tor_grades[index].id) {
          subject.tor_grades[index].manual_grade = null
          subject.tor_grades[index].definitive_grade =
            subject.tor_grades[index].tor_grade
          subject.tor_grades[index].manual_text_selection_value = null
          subject.tor_grades[index].input_active = false
        } else {
          subject.tor_grades = []
        }
      },
      setManualGrade(bewertung) {
        const raw = String(this.tempManualGrade).trim()
        const num = parseFloat(raw.replace(',', '.'))

        bewertung.manual_grade = raw

        // Im CP-Modus wird passed vom Backend nach dem Speichern neu berechnet
        if (!Number.isNaN(num) && !this.isCpVergabe) {
          bewertung.passed = num >= 4
        }

        bewertung.input_active = false
        this.tempManualGrade = null
      },
      setManualTextSelectionValue(bewertung) {
        if (!this.tempManualTextSelectionValue) return

        const v = this.tempManualTextSelectionValue

        // sauberes Objekt speichern
        bewertung.manual_text_selection_value = {
          id: v.id,
          bezeichnung: v.bezeichnung,
        }

        // numerische manuelle Note für Textwahl ist nicht relevant
        bewertung.manual_grade = 0

        bewertung.input_active = false
        this.tempManualTextSelectionValue = null
        this.tempManualGrade = null
      },

      validateManualGrade() {
        //Eingabe in String umwandeln und trimmen
        const value = String(this.tempManualGrade).trim()

        //Ist die Eingabe eine Zahl?
        const numberRegex = /^[0-9]+([.][0-9]+)?$/
        if (!numberRegex.test(value)) {
          return true
        }

        //Eingabe in Zahl umwandeln
        const num = parseFloat(value.replace(',', '.'))
        if (Number.isNaN(num)) {
          return true
        }

        // Im CP-Modus: nur positive Zahl erforderlich (Rohpunkte, z.B. 0–100+)
        if (this.isCpVergabe) {
          return num < 0
        }

        // Im Noten-Modus: Zahl zwischen 1 und 6 mit Dezimalstelle
        if (num < 1 || num > 6) {
          return true
        }

        // Eingabe mindestens eine Dezimalstelle (z.B. 4.0)
        const hasDecimalPart = /[.]\d+$/
        if (!hasDecimalPart.test(value)) {
          return true
        }

        return false
      },
      tooltipManualGrade() {
        const value = String(this.tempManualGrade).trim()

        // Leer: User-Hinweis
        if (!value)
          return this.isCpVergabe
            ? 'Bitte Rohpunkte eingeben'
            : 'Bitte eine Note eingeben'

        // keine Zahl
        const numberRegex = /^[0-9]+([.][0-9]+)?$/
        if (!numberRegex.test(value)) {
          return 'Eingegebener Wert ist keine Zahl'
        }

        // Zahl umwandeln
        const num = parseFloat(value.replace(',', '.'))
        if (Number.isNaN(num)) {
          return 'Ungültige Eingabe — keine gültige Zahl'
        }

        // Im CP-Modus: nur positiv
        if (this.isCpVergabe) {
          if (num < 0) return 'Rohpunkte müssen positiv sein'
          return 'Eingabe bestätigen'
        }

        // Im Noten-Modus: 1–6 mit Dezimalstelle
        if (num < 1 || num > 6) {
          return 'Zulässiger Wertebereich: 1.0 bis 6.0'
        }

        // Dezimalstelle
        if (!/[.]\d+$/.test(value)) {
          return 'Bitte mit Dezimalstelle eingeben (z.B. 4.0)'
        }

        // alles ok
        return 'Eingabe bestätigen'
      },
      tooltipManualGradeInfo(bewertung) {
        if (!bewertung) return ''

        const manualText = bewertung.manual_text_selection_value
        const originalText = bewertung.text_selection_value

        // 1) Textwahlnote manuell angepasst
        if (manualText && manualText.id) {
          let text = 'Diese Textwahlnote wurde manuell angepasst. '

          if (originalText && originalText.id && originalText.bezeichnung) {
            text += `Ursprünglicher Wert: ${originalText.bezeichnung}.`
          } else {
            text += `Neuer Wert: ${manualText.bezeichnung}.`
          }

          return text
        }

        // 2) Numerische Note manuell angepasst
        const hasManualNumber =
          bewertung.manual_grade !== null &&
          bewertung.manual_grade !== undefined &&
          bewertung.manual_grade !== 'NaN' &&
          Number(bewertung.manual_grade) !== 0

        if (hasManualNumber) {
          const hasOriginal =
            bewertung.tor_grade !== null &&
            bewertung.tor_grade !== undefined &&
            bewertung.tor_grade !== 0 &&
            bewertung.tor_grade !== '0' &&
            bewertung.tor_grade !== 'NaN'

          let text = 'Diese Note wurde manuell angepasst. '

          if (hasOriginal) {
            text += `Ursprüngliche Note: ${bewertung.tor_grade}.`
          } else {
            text += `Die Alte Note war nicht vorhanden.`
          }

          return text
        }

        // Fallback
        return 'Diese Note wurde manuell angepasst.'
      },
      istTextwahlBewertung(bewertung) {
        if (!bewertung) return false
        return !!this.getTextwahlObject(bewertung)
      },
      noteHinzufuegenNumerisch(subject) {
        subject.tor_grades.push({
          id: null,
          tor_grade: 0,
          subject: {
            id: subject.id,
            short: subject.short,
            designation: subject.designation,
            cp: subject.cp,
            display: subject.short + ' ' + subject.designation,
            tor_grades: [],
          },
          manual_grade: 0,
          cp: 2,
          credited: false,
          //timestamp: ToDo: wird das fürs backend benötigt?
          passed: null,
          input_active: true,
          definitive_grade: 0,
          text_selection_value: null,
          manual_text_selection_value: null,
          text_choice_value: null,
          manual_text_choice_value: null,
          definitive_text_choice_value: null,
        })
      },

      noteHinzufuegenTextwahl(subject) {
        subject.tor_grades.push({
          id: null,
          tor_grade: 0,
          subject: {
            id: subject.id,
            short: subject.short,
            designation: subject.designation,
            cp: subject.cp,
            display: subject.short + ' ' + subject.designation,
            tor_grades: [],
          },
          manual_grade: 0,
          cp: 2,
          credited: false,
          //timestamp: ToDo: wird das fürs backend benötigt?
          passed: null,
          input_active: true,
          definitive_grade: 0,
          text_selection_value: {
            id: null,
            bezeichnung: null,
          },
          manual_text_selection_value: null,
          text_choice_value: {
            id: null,
            bezeichnung: null,
          },
          manual_text_choice_value: null,
          definitive_text_choice_value: null,
        })
      },
      oeffnePrintoutDatumModal(printout) {
        if (this.selectedPromotionenIDs.length === 0) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nothingselected'),
          })

          return
        }

        this.category = printout.category
        this.printout = printout

        if (this.istNotenuebersichtPrintout(printout)) {
          this.notenuebersichtBloecke = this.getNotenuebersichtBloecke()
          this.$bus.$emit('open-modal', 'notenuebersicht-modul-modal')
          return
        }

        this.$bus.$emit('open-modal', 'datum-pdf-modal')
      },
      validCarbonePrintouts(constant) {
        const validCarbonePrintouts = []
        for (const key in constant) {
          const carboneprint = constant[key]
          if (this.isValidCarbonePrintout(carboneprint)) {
            validCarbonePrintouts.push(carboneprint)
          }
        }
        return validCarbonePrintouts
      },
      isValidCarbonePrintout(printout) {
        if (!printout || !printout.appkey) return false

        const key = printout.appkey.toLowerCase()

        // true nur wenn "zeugnis" im Namen vorkommt oder es die Notenübersicht ist
        return key.includes('zeugnis') || this.istNotenuebersichtPrintout(printout)
      },
      istNotenuebersichtPrintout(printout) {
        return printout?.appkey?.toLowerCase() === NOTENUEBERSICHT_APPKEY
      },

      generiereCarboneReport(date, typ) {
        this.carboneDate = date
        this.carboneTyp = typ
        // this.carboneInstitution = institution
        this.carbone()
      },
      carbone() {
        this.loading = true

        let endpoint = 'carbone/'

        if (this.selectedIds?.length === 0) {
          this.loading = false
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
        } else {
          const zeugnisse = this.buildZeugnisPayload()

          CarboneApi.post(
            endpoint,
            {
              // Request-Body / Payload
              promotionen: zeugnisse.zeugnisse,
              abschluss: zeugnisse.abschluss,
            },
            {
              // Query-Parameter wie vorher
              params: {
                template: this.printout.template,
                category: this.category?.bezeichnung,
                date: this.carboneDate,
                type: this.carboneTyp,
                institution: this.carboneInstitution?.id,
                veranstaltung: this.veranstaltung?.id,
              },
            }
          )
            .then((response) => {
              this.pdfFiles = response.data.map((item) => ({
                url: server.url + item.url,
                name: item.name,
                count: item.count,
                size: item.name,
              }))

              this.pdfFiles.length > 0
                ? this.$refs.pdfLayerPromotion.show()
                : this.$notify({
                    type: 'warn',
                    title: this.$t('global.actionfailed'),
                    text: 'Es ist ein Fehler aufgetreten',
                  })
            })
            .catch((error) => {
              console.error('Error fetching PDF files:', error)
            })
            .finally(() => {
              this.loading = false
              this.$refs.pdfLayerPromotion.loading = false
            })
        }
      },
      startRepetentenprozess() {
        // sicherstellen, dass die Auswahl aktuell ist
        if (!this.selectedObjects || this.selectedObjects.length === 0) {
          this.selectedObjects = this.$refs.selectableTable.items.filter(
            (item) => item.selected
          )
        }

        if (!this.selectedObjects.length) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
          return
        }

        // Personen + Fächer (nicht bestandene Noten) aus den ausgewählten Promotionen bauen
        const personen = this.selectedObjects
          .map((promotion) => {
            const personId = promotion.student && promotion.student.id
            const faecher = []

            // nur den aktuell gewählten Promotionsblock verwenden
            const block = (promotion.promotionblocks || [])[
              this.aktiverPromotionsblock
            ]

            if (!block) {
              return { personId, faecher }
            }

            const promotionGroups = block.promotiongroups || []

            promotionGroups.forEach((group) => {
              const subjects = group.subjects || []

              subjects.forEach((subject) => {
                const torGrades = subject.tor_grades || []

                // nur Noten mit passed === false
                torGrades
                  .filter((tg) => tg.passed === false)
                  .forEach((tg) => {
                    let note

                    if (tg.definitive_text_selection_value) {
                      // z.B. "Nicht bestanden" als Text belassen
                      note = tg.definitive_text_selection_value.bezeichnung
                    } else {
                      const rawNote = tg.definitive_grade || tg.tor_grade

                      const numericNote =
                        typeof rawNote === 'string'
                          ? parseFloat(rawNote.replace(',', '.'))
                          : rawNote

                      // hier wird aus der Zahl ein String wie "4.0" oder "2.5"
                      note = numericNote.toFixed(1)
                    }

                    faecher.push({
                      fachId: subject.id,
                      bezeichnung: subject.designation,
                      note, // ist jetzt immer ein String
                    })
                  })
              })
            })

            return {
              personId,
              faecher,
            }
          })
          .filter((person) => person.personId && person.faecher.length > 0)

        if (!personen.length) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: 'Es wurden keine nicht bestandenen Fächer gefunden.',
          })
          return
        }

        // RequestRepetentenDTO aufbauen
        const payload = {
          mitarbeiterId: this.angemeldeterMitarbeiter.person.id,
          personen: personen,
        }

        this.isBusy = true

        AppApi.post('repetenten-aktivitaet', payload)
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text:
                this.$t('global.activities') + ' ' + this.$t('global.created'),
            })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
            this.ladeFehler = true
          })
          .finally(() => {
            this.isBusy = false
          })
      },
      buildZeugnisPayload() {
        const payload = (this.selectedObjects || []).map((promotion) => {
          const student = promotion.student || {}
          const blocks = promotion.promotionblocks || []
          const maxIndex = this.aktiverPromotionsblock || 0
          const promotiongroups = []
          const testate = [] // <— neu

          blocks.forEach((block, i) => {
            if (i > maxIndex) return
            ;(block.promotiongroups || []).forEach((group) => {
              const titel =
                group.designation?.split(' - ').slice(1).join(' - ').trim() ||
                group.designation
              const subjects = []

              ;(group.subjects || []).forEach((subject) => {
                const best = this.getHoechsteNote(subject)
                const noteNum = this.getEffectiveNumericGrade(best)
                const noteText = this.getAnzeigeNote(best)
                const textObj = this.getTextwahlObject(best)

                const fach = {
                  fachBezeichnung: subject.designation,
                  noteNum,
                  noteText,
                  textwahl: textObj?.bezeichnung ?? null,
                  passed: best?.passed ?? null,
                }

                // hier trennen:
                if (this.istTextwahlBewertung(best)) {
                  testate.push(fach)
                } else {
                  subjects.push(fach)
                }
              })

              if (subjects.length > 0) {
                promotiongroups.push({
                  titel,
                  durchschnitt: group.average_grade,
                  subjects,
                })
              }
            })
          })

          return {
            promotionId: promotion.id,
            personId: student.id,
            vorname: student.name,
            nachname: student.lastname,
            promotionsblock: {
              bezeichnung: blocks[maxIndex]?.designation,
              durchschnitt: blocks[maxIndex]?.average_grade,
              promotiongroups,
            },
            testate, // <— jetzt Teil des Payloads!
          }
        })

        const selectedPlan = (this.ausbildungsplaene || []).find(
          (p) => p.id === this.ausbildungsplan
        )
        return {
          abschluss: selectedPlan?.bezeichnung ?? null,
          zeugnisse: payload,
        }
      },

      // Studienjahre (Promotionsblöcke) für das Notenübersicht-Modal,
      // hatNoten = mindestens eine ausgewählte Person hat dort eine Note
      getNotenuebersichtBloecke() {
        const bloecke = []
        ;(this.selectedObjects || []).forEach((promotion) => {
          const bloeckeDerPerson = promotion.promotionblocks || []
          bloeckeDerPerson.forEach((block, index) => {
            if (!bloecke[index]) {
              bloecke[index] = {
                index,
                bezeichnung: block.designation,
                hatNoten: false,
              }
            }
            const hatNoten = (block.promotiongroups || []).some((group) =>
              (group.subjects || []).some((subject) =>
                this.hatNotenuebersichtNote(this.getHoechsteNote(subject))
              )
            )
            if (hatNoten) bloecke[index].hatNoten = true
          })
        })
        return bloecke.filter(Boolean)
      },
      hatNotenuebersichtNote(grade) {
        if (!grade) return false
        if (this.istTextwahlBewertung(grade)) return true
        const note = this.getEffectiveNumericGrade(grade)
        return note !== null && note > 0
      },
      generiereNotenuebersicht(optionen) {
        this.loading = true

        CarboneApi.post('carbone/', this.buildNotenuebersichtPayload(optionen), {
          params: {
            template: this.printout.template,
            category: this.category?.bezeichnung,
            veranstaltung: this.veranstaltung?.id,
          },
        })
          .then((response) => {
            this.pdfFiles = response.data.map((item) => ({
              url: server.url + item.url,
              name: item.name,
              count: item.count,
              size: item.name,
            }))

            this.pdfFiles.length > 0
              ? this.$refs.pdfLayerPromotion.show()
              : this.$notify({
                  type: 'warn',
                  title: this.$t('global.actionfailed'),
                  text: 'Es ist ein Fehler aufgetreten',
                })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.loading = false
            this.$refs.pdfLayerPromotion.loading = false
          })
      },
      buildNotenuebersichtPayload({ bloecke, ohneNoteAnzeigen, publish }) {
        const personen = (this.selectedObjects || []).map((promotion) => {
          const moduleListe = []
          const testate = []

          ;(promotion.promotionblocks || []).forEach((block, index) => {
            if (!bloecke.includes(index)) return
            ;(block.promotiongroups || []).forEach((group) => {
              // "W01 - Business Basics" / "W05 – Project & Change" -> Titel ohne Code
              const titel =
                group.designation?.split(/\s[-–]\s/).slice(1).join(' - ').trim() ||
                group.designation
              const istTestatGruppe = /testat/i.test(group.designation || '')
              const faecher = []

              ;(group.subjects || []).forEach((subject) => {
                // bei Wiederholungen zählt die beste Note
                const best = this.getHoechsteNote(subject)
                const textObj = this.getTextwahlObject(best)

                if (istTestatGruppe || textObj) {
                  const wert = textObj?.bezeichnung ?? null
                  if (wert || ohneNoteAnzeigen)
                    testate.push({ bezeichnung: subject.designation, wert })
                  return
                }

                const note = this.getEffectiveNumericGrade(best)
                const hatNote = note !== null && note > 0
                if (hatNote || ohneNoteAnzeigen)
                  faecher.push({
                    bezeichnung: subject.designation,
                    note: hatNote ? note : null,
                  })
              })

              if (faecher.length === 0) return
              moduleListe.push({
                bezeichnung: titel,
                // average_grade = gewichteter Schnitt der bereits benoteten Fächer
                note: group.average_grade > 0 ? group.average_grade : null,
                faecher,
              })
            })
          })

          return {
            personId: promotion.student?.id,
            module: moduleListe,
            testate,
          }
        })

        return { publish, personen }
      },
    },
  }
</script>
<style scoped>
  .note-edit-icon {
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
    cursor: pointer;
  }

  .note-display-wrapper:hover .note-edit-icon {
    opacity: 1;
  }
</style>
